import { XbotPageContext, XbotStartersAbout, XbotStartersNote } from "@dto/pyxbot-agent.dto";
import { FC } from "react";
import { askingAboutText } from "../pageContext";

interface Props {
  context: XbotPageContext | null | undefined;
  /** The page's object as NG answered it for this person, once the service has said it; its words win. */
  about?: XbotStartersAbout | null;
  /** Why the service said no object: when NG does not show it to the person, the bar is not drawn. */
  note?: XbotStartersNote | null;
  /** Drops the page from the thread; the bar goes with it, because there is nothing left to say. */
  onForget?: () => void;
}

// Shown as one sentence, not a row of tokens, so the person reads it once and moves on or forgets it.
export const AskingAboutBar: FC<Props> = ({ context, about, note, onForget }) => {
  const sentence = askingAboutText(context, about, note);
  if (!sentence) {
    return null;
  }
  return <div className="xm-chat-asking-about">
    <span className="xm-chat-asking-about-text">{sentence}</span>
    {onForget && <button type="button" className="xm-chat-forget" onClick={onForget}>forget</button>}
  </div>;
};
